/**
 * Implements generic method for scrolling to a row of a table containing a target element, 
 * that is possibly rendered delayed.
 * 
 * Automatically highlights the row of the target item, if found.
 * 
 */
export class ItemScroller {
    private _highlightedRow: HTMLElement | null | undefined = undefined
    private _lastItemFound: HTMLElement | null | undefined = undefined
    private _lastItemFoundCount: number = 0

    scrollToItem(targetFunc: () => HTMLElement | null | undefined, smoothScrolling: boolean) {
        this._lastItemFound = undefined
        this._lastItemFoundCount = 0
        this.tryToScroll(targetFunc, smoothScrolling, 1)
    }

    private tryToScroll(targetFunc: () => HTMLElement | null | undefined,
        smoothScrolling: boolean,
        attemptCount: number)
    {
        const target = targetFunc()

        if (target == null) {
            // item not rendered yet, make new attempt later

            if (attemptCount > 50) return // give up
            setTimeout(() => this.tryToScroll(targetFunc, smoothScrolling, attemptCount + 1), 100)
            return
        }

        if (target != this._lastItemFound) {
            target.scrollIntoView({ block: 'center', behavior: smoothScrolling ? 'smooth' : 'auto' })

            if (this._highlightedRow) {
                this._highlightedRow.classList.remove('row-highlighted')
            }

            this._highlightedRow = this.GetNearestParentRowTag(target)

            if (this._highlightedRow) {
                this._highlightedRow.classList.add('row-highlighted')
            }

            this._lastItemFound = target
        }
        else {
            this._lastItemFoundCount++
        }

        if (this._lastItemFoundCount <= 5) {
            // HACK: If the targetFunc performs a "chained search", the right target might not be returned first time
            setTimeout(() => this.tryToScroll(targetFunc, smoothScrolling, attemptCount + 1), 100)
        }
    }

    private GetNearestParentRowTag(element: HTMLElement): HTMLElement | null {
        let currentElement: HTMLElement | null = element

        do {
            if (currentElement?.tagName == 'TR') {
                return currentElement
            }

            currentElement = currentElement?.parentElement
        } while (currentElement != null)

        return null
    }

}